package pl.decks.personal.components.widgets.timeline

import com.varabyte.kobweb.compose.css.StyleVariable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.theme.colors.palette.border
import com.varabyte.kobweb.silk.theme.colors.palette.color
import com.varabyte.kobweb.silk.theme.colors.palette.toPalette
import org.jetbrains.compose.web.css.times
import pl.decks.personal.components.widgets.timeline.MonthlyTimelineStylesheet.Vars.yearLabelColor
import pl.decks.personal.styles.FontTypography
import pl.decks.personal.styles.SiteLayout

object MonthlyTimelineStylesheet {
    object Vars {
        val markerHeight by StyleVariable(SiteLayout.Space.XXSmall)
        val markerColor by StyleVariable<Color>()

        val yearBreakColor by StyleVariable<Color>()
        val yearLabelColor by StyleVariable<Color>()
        val yearLabelFontSize by StyleVariable(FontTypography.Size.Relative.Same)
        val monthLabelFontSize by StyleVariable(FontTypography.Size.Relative.Smaller)

        val timelineHeight by StyleVariable(SiteLayout.Space.Medium)
    }


    val RoundedBarMarker = CssStyle.base {
        Modifier
            .fillMaxWidth()
            .borderRadius(SiteLayout.Rounding.Full)
            .height(Vars.markerHeight.value())
            .backgroundColor(Vars.markerColor.value(colorMode.toPalette().border))
    }
    val CircleMarker = CssStyle.base {
        Modifier
            .height(2 * Vars.markerHeight.value())
            .aspectRatio(1)
            .borderRadius(SiteLayout.Rounding.Full)
            .backgroundColor(Vars.markerColor.value(colorMode.toPalette().border))
    }
    val YearLabelContainer = CssStyle.base {
        Modifier
            .fillMaxWidth()
            .height(Vars.yearLabelFontSize.value() * 2.5)
            .fontSize(Vars.yearLabelFontSize.value())
    }
    val YearLabel = CssStyle.base {
        Modifier
            .color(yearLabelColor.value(colorMode.toPalette().color))
            .margin(leftRight = Vars.yearLabelFontSize.value() * 0.5)
    }
    val TimelineContainer = CssStyle.base {
        Modifier.fillMaxWidth().height(Vars.timelineHeight.value())
    }
    val MonthLabelsContainer = CssStyle.base {
        Modifier
            .fillMaxWidth()
            .height(Vars.monthLabelFontSize.value() * 2.5)
            .fontSize(Vars.monthLabelFontSize.value())
    }
}
